var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popup",class:_vm.isPopupClass},[_c('Header'),_c('perfect-scrollbar',{ref:"popupScroll",staticClass:"popup_scroll"},[_c('router-view',{staticClass:"contents"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }